// Horizontal bounds shared by the item-view content column and the bottom-pinned
// update composer, so the two line up exactly. The composer is position:fixed and
// can't inherit the section's layout, so both must reference this single value —
// change the margins here and both move together.
//
// `pl-6 pr-4` gives a little more breathing room on the left than the right;
// `max-w-[640px]` keeps the column narrow enough that, on wider panels, its right
// edge clears the Crisp launcher sitting in the bottom-right gutter.
export const ITEM_VIEW_COLUMN = "mx-auto max-w-[640px] pl-6 pr-4";
